/** @file Factory for `<domain>.rename` commands: resolve the target, check the new name, assign it. */
import { z } from 'zod';
import type { EntityKind } from '@pose2d/format/types';
import { defineCommand, type CommandDef } from '../defineCommand';
import { assertFreeName } from './assertFreeName';
import { entityDraft } from './entityDraft';

/** Builds `<domain>.rename` with input `{ target, name }`; renaming to the current name is allowed (no NAME_TAKEN). */
export function defineRename(spec: { domain: string; kind: EntityKind; description: string }): CommandDef<{ target: string; name: string }> {
  return defineCommand({
    name: `${spec.domain}.rename`,
    description: spec.description,
    input: z.object({ target: z.string().min(1), name: z.string().min(1) }).strict(),
    apply(draft, input, ctx) {
      const id = ctx.resolve(spec.kind, input.target);
      assertFreeName(ctx, spec.kind, input.name, id);
      entityDraft(draft, spec.kind, id).name = input.name;
      draft.meta.updatedAt = ctx.now;
    },
  });
}
